import { render, staticRenderFns } from "./carrossel.vue?vue&type=template&id=042d4560&scoped=true"
import script from "./carrossel.vue?vue&type=script&lang=js"
export * from "./carrossel.vue?vue&type=script&lang=js"
import style0 from "./carrossel.vue?vue&type=style&index=0&id=042d4560&prod&lang=css"
import style1 from "./carrossel.vue?vue&type=style&index=1&id=042d4560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d4560",
  null
  
)

export default component.exports